// @ts-nocheck
import { AGE_GROUPS, QUESTIONS } from '../data/liveDemoData';

export const DIMS = [
  "Learning behaviour",
  "Emotional intelligence",
  "Attention span",
  "Academic strengths",
  "Social interaction",
  "Behavioural challenges",
];

export function ageGroupFor(age) {
  const value = Number(age) || 0;
  return AGE_GROUPS.find((group) => value >= group.minAge && value <= group.maxAge) || AGE_GROUPS[1];
}

export function computeProfile(groupId, answers) {
  const questions = QUESTIONS[groupId] || [];
  const byDim = {};
  let sum = 0;
  let count = 0;

  questions.forEach((question) => {
    const key = `${groupId}:${question.id}`;
    if (answers[key] !== undefined) {
      const value = question.options[answers[key]].v;
      byDim[question.dim] = byDim[question.dim] || { sum: 0, count: 0 };
      byDim[question.dim].sum += value;
      byDim[question.dim].count += 1;
      sum += value;
      count += 1;
    }
  });

  const dims = DIMS.map((dim) => {
    const present = questions.some((question) => question.dim === dim);
    const has = !!byDim[dim];
    const pct = has ? Math.round((byDim[dim].sum / byDim[dim].count / 3) * 100) : 0;
    return { dim, present, has, pct };
  });
  const overall = count ? sum / count / 3 : 0;
  const needsMet = count ? Math.round(52 + overall * 43) : 0;

  return { dims, overall, needsMet, answered: count, total: questions.length };
}

export function meterColor(pct) {
  if (pct >= 67) return "var(--green)";
  if (pct >= 34) return "var(--blue)";
  return "var(--amber)";
}
